<script lang="ts">
	import Image from '$lib/components/image.svelte';
	import type { UploadFileFieldsFragment } from '$lib/graphql/strapiApi';
	import { replaceImg } from '$lib/utils.js';
	import { mode } from '$lib/state/global.svelte';

	type Feature = {
		title?: string | null;
		description?: string | null;
		richDescription?: { body?: string | null } | null;
		icon?: UploadFileFieldsFragment | null;
		darkIcon?: UploadFileFieldsFragment | null;
	};

	let {
		title,
		description,
		features
	}: {
		title?: string | null;
		description?: string | null;
		features: Feature[];
	} = $props();

	const gridCols = $derived.by(() => {
		const count = features.length;
		if (count === 1) return 'grid-cols-1';
		if (count === 2) return 'grid-cols-1 sm:grid-cols-2';
		if (count === 3) return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3';
		return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4';
	});
</script>

<div>
	<div class="mb-16 text-center">
		{#if title}
			<h2 class="mb-6 text-4xl font-bold">{title}</h2>
		{/if}
		{#if description}
			<p class="mx-auto max-w-4xl text-xl text-gray-600">{description}</p>
		{/if}
	</div>

	<div class="mx-auto grid max-w-6xl gap-8 {gridCols}">
		{#each features as feature}
			<div class="flex flex-col items-center text-center">
				{#if ($mode === 'dark' && feature.darkIcon?.url) || feature.icon?.url}
					<div class="mb-6 flex h-16 w-16 items-center justify-center">
						<Image
							class="h-full w-full object-contain"
							src={replaceImg(
								$mode === 'dark' && feature.darkIcon?.url
									? feature.darkIcon.url
									: feature.icon?.url,
								'medium'
							)!}
							alt={feature.title || ''}
						/>
					</div>
				{/if}
				<h3 class="mb-4 h-12 text-xl font-semibold leading-6">{feature.title}</h3>
				<p class="leading-relaxed {$mode === 'dark' ? 'text-gray-300' : 'text-gray-600'}">
					{@html feature.richDescription?.body || feature.description}
				</p>
			</div>
		{/each}
	</div>
</div>
